import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import moment from 'moment'
import { Columns, Column } from '@resurs/midas-react'
import TrendChart from './TrendChart'
import PaginatedTopList from './PaginatedTopList'
import { getText } from '../../../internal/TextLabels'

import styles from './statisticsTopList.style'

class StatisticsTopList extends Component {
  constructor(props) {
    super(props)

    const now = new Date()
    const locale = 'sv-SE'
    /* eslint-disable */
    this.state = {
      year: now.getFullYear().toString(),
      month: now.toLocaleString(locale, { month: 'long' }),
      week: `V${moment(now).isoWeek()}`,
      type: 'table',
      timespan: 'month',
      scope: '',
      target: '',
      title: props.representativeName,
      barChartLabel: props.storeName,
    }
    /* eslint-enable */
  }

  setChartType(type, name, userId) {
    this.props.showTrend(userId)
    this.setState(state =>
      update(state, {
        type: { $set: type },
        barChartLabel: { $set: name },
      }),
    )
  }

  buildChart() {
    if (this.state.type === 'bar') {
      return (
        <TrendChart
          data={this.props.data.trend}
          label={this.state.barChartLabel}
          dllink={getText('statistics.dllink')}
        />
      )
    }
    return (
      <div>
        <PaginatedTopList
          data={this.props.data.list}
          detail={(t, n, uid) => this.setChartType(t, n, uid)}
        />
      </div>
    )
  }

  render() {
    return (
      <Columns>
        <Column col12>
          <div style={styles.board}>
            <div>
              <div>
                <Columns>
                  <Column col10>
                    <h3 style={styles.title}>
                      {getText('statistics.revenue')} -{' '}
                      {this.state.barChartLabel}
                    </h3>
                    <div style={styles.period}>
                      {getText('statistics.description')}
                    </div>
                    <span style={styles.period}>
                      <strong>{getText('statistics.timespan')}:</strong>{' '}
                      {this.props.period}
                    </span>
                  </Column>
                </Columns>
              </div>
              {this.props.data.list.length ? this.buildChart() : null}
            </div>
          </div>
        </Column>
      </Columns>
    )
  }
}

StatisticsTopList.propTypes = {
  data: PropTypes.object.isRequired,
  representativeName: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  showTrend: PropTypes.func.isRequired,
}

export default StatisticsTopList
